const tableTitleManagementEquip = {
  title: 'Gestão dos Equipamentos',
  placeholder: 'Pesquisar pelos campos: número de série, marca, especificação e referência',
  helperTextSearch: 'Para pesquisar pelo nome do equipamento utilize o filtro de tipo do equipamento',
  addRowLabel: 'novo equipamento'
};

export default tableTitleManagementEquip;
